<div class="general-shareholders">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#shareholder-doc'"></app-title-page>
            </div>
            <!-- documents -->
            <div class="col-md-12 documents" id="shareholder-doc">
                <div class="lane-top">
                    <div class="row mt-5">
                        <!-- Annual General Meeting of Shareholders -->
                        <div class="col-md-12">
                            <h3 class="f-subtit mb-3">{{ dataSection[0]?.title }}</h3>
                            <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                            <div class="statements mt-4" *ngIf="yearAnnual">
                                <div class="row">
                                    <div class="col-lg-3 col-md-4 col-sm-7 col-10 mx-md-0 mx-auto">
                                        <h5 class="tit-f18b text-md-left text-center">{{ isLang?.selectYears }}</h5>
                                        <div class="select-ver2 mt-3">
                                            <ng-select2 [(ngModel)]="yearAnnual"
                                                        [data]="dataYearAnnual" 
                                                        [placeholder]="isLang?.selectYears"
                                                        (valueChanged)="valueChangedAnnual($event)">
                                            </ng-select2>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4" *ngIf="dataPerAnnual">
                                    <app-widget-pdf [isActive]="isActivePdf" [dataWidgetPdf]="dataPerAnnual"></app-widget-pdf>
                                </div>
                            </div>
                        </div>
                        <!-- extraordinary -->
                        <div class="col-md-12 mt-5">
                            <h3 class="f-subtit mb-3">{{ dataSection[1]?.title }}</h3>
                            <div class="desc text-justify" [innerHTML]="dataSection[1]?.content"></div>
                            <div class="statements mt-4" *ngIf="yearExtra">
                                <div class="row">
                                    <div class="col-lg-3 col-md-4 col-sm-7 col-10 mx-md-0 mx-auto">
                                        <h5 class="tit-f18b text-md-left text-center">{{ isLang?.selectYears }}</h5>
                                        <div class="select-ver2 mt-3">
                                            <ng-select2 [(ngModel)]="yearExtra"
                                                        [data]="dataYearExtra" 
                                                        [placeholder]="isLang?.selectYears"
                                                        (valueChanged)="valueChangedExtra($event)">
                                            </ng-select2>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4" *ngIf="dataPerExtra">
                                    <app-widget-pdf [isActive]="isActivePdf" [dataWidgetPdf]="dataPerExtra"></app-widget-pdf>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>
